import { useState, useEffect } from "react";
import moment from "moment";
import InputNumber from "../../../../../shared/components/inputs/InputNumber/InputNumber";
import InputText from "../../../../../shared/components/inputs/InputText/InputText";
import InputSelect from "../../../../../shared/components/inputs/InputSelect/InputSelect";
import { Link } from "react-router-dom";
//MUI
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import Autocomplete from "@mui/material/Autocomplete";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import { useLoading } from "../../../../../shared/context/LoadingContext";
import toast from "react-hot-toast";
import "./ModalSaida.scss";
import {
  caixasPermitidas,
  caixaParaMetodo,
  metodoParaCaixa,
} from "../../../../../shared/util/caixaEMetodo";

const formasPagamento = [
  "Dinheiro",
  "Cheque",
  "Cheque Visado",
  "Transferência de crédito",
  "Internet banking",
  "Cartão do banco",
  "Débito direto da conta bancária",
  "Cartão de crédito",
  "Cartão de débito",
];

function ModalSaida({
  openModalSaida,
  handleCloseModalSaida,
  sendRequest,
  clinicaId,
  updateSaidas,
  auth,
}) {
  const { startLoading, stopLoading } = useLoading();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openModal, setOpenModal] = useState(openModalSaida);
  const [descricao, setDescricao] = useState("");
  const [valor, setValor] = useState(0);
  const [observacao, setObservacao] = useState("");
  const [categoria, setCategoria] = useState();
  const [categorias, setCategorias] = useState([]);
  const [caixa, setCaixa] = useState();
  const [caixas, setCaixas] = useState([]);
  const [dataLimitePagamento, setDataLimitePagamento] = useState(moment());
  const [comprovativo, setComprovativo] = useState();
  const [errorMessage, setErrorMessage] = useState();
  const [saidaPaga, setSaidaPaga] = useState(false);
  const [dataPagamento, setDataPagamento] = useState(moment());

  const [metodoPagamento, setMetodoPagamento] = useState(formasPagamento[0]);

  /* Quando se marca «já foi paga», a caixa tem de obedecer ao método — e a que
     estava escolhida pode já não servir. */
  useEffect(() => {
    if (saidaPaga) {
      setCaixa((atual) => caixaParaMetodo(caixas, metodoPagamento, atual));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saidaPaga]);

  const [listaFornecedores, setListaFornecedores] = useState([]);
  const [fornecedor, setFornecedor] = useState("");
  const [fornecedorTexto, setFornecedorTexto] = useState("");
  const [listaClientes, setListaClientes] = useState([]);
  const [cliente, setCliente] = useState("");
  const [tipoBeneficiario, setTipoBeneficiario] = useState("fornecedor");

  const [listaFuncionariosEUtilizadores, setListaFuncionariosEUtilizadores] =
    useState([]);
  const [funcionarioSelecionado, setFuncionarioSelecionado] = useState(null);

  //Cheque
  const [banco, setBanco] = useState("");
  const [nrContaCliente, setNrContaCliente] = useState("");
  const [nrCheque, setNrCheque] = useState("");
  const [dataCheque, setDataCheque] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      startLoading();
      try {
        const [
          categoriasResponse,
          caixasResponse,
          fornecedoresResponse,
          clientesResponse,
          funcionariosResponse,
          utilizadoresResponse,
        ] = await Promise.all([
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/categoriasfinanceiro/clinica/despesa/${clinicaId}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/caixas/clinica/${clinicaId}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/fornecedores/clinica/despesa/${clinicaId}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/clientes/nomeid/${clinicaId}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/funcionarios/clinica/${clinicaId}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/users/ativos/${clinicaId}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
        ]);

        // Process categorias
        const categoriasFormatted = categoriasResponse.categoriasFinanceiro.map(
          (cat) => ({
            id: cat.id,
            value: cat.categoria,
          }),
        );

        setCategorias(categoriasFormatted);
        setCategoria(categoriasFormatted[0]?.id);

        // Process caixas
        const caixasFormatted = caixasResponse.caixas.map((cai) => ({
          id: cai.id,
          value: cai.caixa,
        }));
        setCaixas(caixasFormatted);

        // Process fornecedores
        const fornecedoresFormatted = fornecedoresResponse.fornecedores.map(
          (forn) => ({
            id: forn.id,
            value: forn.nome,
          }),
        );

        setListaFornecedores(fornecedoresFormatted);
        setListaClientes(clientesResponse.clientes);

        setCaixa(caixasFormatted[0]?.id);

        // Combinar numa lista única com flag de tipo
        const funcionariosFormatted = funcionariosResponse.funcionarios.map(
          (f) => ({
            id: f.id,
            value: f.nome,
            tipo: "Funcionario",
          }),
        );

        const utilizadoresFormatted = utilizadoresResponse.users.map((u) => ({
          id: u.id,
          value: u.name, // ajustar ao campo correto do modelo User
          tipo: "User",
        }));

        setListaFuncionariosEUtilizadores([
          ...funcionariosFormatted,
          ...utilizadoresFormatted,
        ]);
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    };

    fetchData();
  }, [auth.token, clinicaId, sendRequest]);

  useEffect(() => {
    setOpenModal(openModalSaida);
  }, [openModalSaida]);

  const descricaoChangeHandler = (value) => {
    setDescricao(value);
  };

  const valorChangeHandler = (value) => {
    setValor(value);
  };

  /* Método e caixa andam juntos: dinheiro é da caixa "Clínica", tudo o resto
     sai de um banco. Mudar um acerta o outro, e a lista de caixas só mostra as
     que o método permite. Ver `shared/util/caixaEMetodo`. */
  const metodoPagamentoChangeHandler = (valor) => {
    setMetodoPagamento(valor);
    setCaixa((atual) => caixaParaMetodo(caixas, valor, atual));
  };

  const caixaChangeHandler = (novaCaixa) => {
    setCaixa(novaCaixa);
    setMetodoPagamento((atual) =>
      metodoParaCaixa(caixas, novaCaixa, atual, formasPagamento),
    );
  };

  const guardarSaidaHandler = async () => {
    startLoading();
    try {
      const formData = new FormData();
      formData.append("clinica", clinicaId);
      formData.append("observacoes", observacao ? observacao : "");
      formData.append("descricao", descricao);
      formData.append("valor", valor);
      formData.append("dataLimitePagamento", dataLimitePagamento);
      formData.append("categoria", categoria);
      formData.append("caixa", caixa);
      formData.append("criadoPor", auth.userId);
      if (fornecedor) formData.append("fornecedor", fornecedor);
      if (fornecedorTexto) formData.append("fornecedorTexto", fornecedorTexto);
      if (cliente) formData.append("cliente", cliente);
      if (comprovativo) {
        const modifiedFile = new File(
          [comprovativo],
          `${clinicaId}-${comprovativo.name}`,
          { type: comprovativo.type },
        );
        formData.append("comprovativo", modifiedFile);
      }

      if (saidaPaga) {
        formData.append("dataPagamento", dataPagamento);
        formData.append("metodoPagamento", metodoPagamento);
        formData.append("despesaPaga", true);
        formData.append("pagaPor", auth.userId);

        if (
          metodoPagamento === "Cheque" ||
          metodoPagamento === "Cheque Visado"
        ) {
          formData.append("banco", banco);
          formData.append("nrContaCliente", nrContaCliente);
          formData.append("nrCheque", nrCheque);
          formData.append("dataCheque", dataCheque);
        }
      } else {
        formData.append("despesaPaga", false);
      }

      if (funcionarioSelecionado) {
        if (funcionarioSelecionado.tipo === "Funcionario") {
          formData.append("funcionario", funcionarioSelecionado.id);
        } else {
          formData.append("funcionarioUser", funcionarioSelecionado.id);
        }
      }

      //LEMBRA DE ADICIONAR COMPROVATIVO MAIS TARDE
      const saidaAdicionada = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/despesas`,
        "POST",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      updateSaidas(saidaAdicionada.despesa);
      toast.success("Saída adicionada com sucesso!");
    } catch (err) {
      console.error("err", err);
    } finally {
      setIsSubmitting(false);
      stopLoading();
      handleCloseModalSaida();
    }
  };

  const preGuardarSaidaHandler = () => {
    if (valor === 0) {
      toast.error("O valor da saída não pode ser 0");
    } else if (!descricao || descricao.trim() === "") {
      toast.error("Introduza a descrição");
    } else if (!dataLimitePagamento) {
      toast.error("Introduza a data de limite de pagamento");
    } else if (
      !moment.isMoment(dataLimitePagamento) ||
      !dataLimitePagamento.isValid()
    ) {
      toast.error("Introduza a data de limite de pagamento corretamente");
    } else if (saidaPaga && !dataPagamento) {
      toast.error("Introduza a data de pagamento");
    } else if (
      saidaPaga &&
      (!moment.isMoment(dataPagamento) || !dataPagamento.isValid())
    ) {
      toast.error("Introduza a data de pagamento corretamente");
    } else if (
      saidaPaga &&
      (metodoPagamento === "Cheque" || metodoPagamento === "Cheque Visado") &&
      (!nrContaCliente || nrContaCliente.trim() === "")
    ) {
      toast.error("Introduza o número da conta do cliente");
    } else if (
      saidaPaga &&
      (metodoPagamento === "Cheque" || metodoPagamento === "Cheque Visado") &&
      (!nrCheque || nrCheque.trim() === "")
    ) {
      toast.error("Introduza o número do cheque");
    } else if (
      saidaPaga &&
      (metodoPagamento === "Cheque" || metodoPagamento === "Cheque Visado") &&
      !dataCheque
    ) {
      toast.error("Introduza a data do cheque");
    } else if (
      saidaPaga &&
      (metodoPagamento === "Cheque" || metodoPagamento === "Cheque Visado") &&
      (!moment.isMoment(dataCheque) || !dataCheque.isValid())
    ) {
      toast.error("Introduza a data do cheque corretamente");
    } else if (!isSubmitting) {
      setIsSubmitting(true);
      guardarSaidaHandler();
    }
  };

  const handleFileChange = (event) => {
    // Check file size (1MB limit)
    const maxSizeInBytes = 1 * 1024 * 1024; // 3MB in bytes
    const file = event.target.files[0];
    // Check file extension
    const allowedExtensions = /(\.jpg|\.jpeg|\.png\.pdf|)$/i;
    if (!allowedExtensions.test(file.name)) {
      setErrorMessage(`O ficheiro "${file.name}" tem uma extensão inválida.`);
    } else if (file.size > maxSizeInBytes) {
      setErrorMessage(
        `O ficheiro "${file.name}" excede o tamanho máximo permitido (1MB).`,
      );
    } else {
      setErrorMessage("");
      setComprovativo(file);
    }
  };

  const handleClienteChange = (value) => {
    setCliente(value);
  };

  const handleFornecedorChange = (value, isTexto = false) => {
    if (isTexto) {
      setFornecedorTexto(value);
      setFornecedor(null);
    } else {
      setFornecedor(value);
      setFornecedorTexto("");
    }
  };

  return (
    <>
      <Modal
        open={openModal}
        onClose={handleCloseModalSaida}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          className="fluxo-atendimento__modal__box adicionar-despesa__modal"
          id="modal__adicionar-despesa"
        >
          <h1 className="fluxo-atendimento__modal__titulo">Nova saída</h1>
          <div className="adicionar-despesa__modal__container">
            <InputText
              className="adicionar-despesa__modal__container--span2"
              label="Descrição *"
              initialValue={descricao}
              handleChange={descricaoChangeHandler}
            />
            <InputNumber
              className="adicionar-despesa__modal__container--span1"
              label="Valor *"
              initialValue={valor}
              handleChange={valorChangeHandler}
            />
            <LocalizationProvider
              dateAdapter={AdapterMoment}
              className="adicionar-despesa__modal__container--span1"
            >
              <DesktopDatePicker
                className="valorDataCaixa__fields--field muiDatePicker"
                label="Data de vencimento*"
                inputFormat="DD-MM-YYYY"
                value={dataLimitePagamento}
                onChange={(value) => setDataLimitePagamento(value)}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>

            <div className="adicionar-despesa__modal__container--span2">
              <div className="customInputContainer">
                <select
                  onChange={(e) => {
                    setTipoBeneficiario(e.target.value);
                    // Limpa os valores ao trocar
                    setCliente("");
                    setFornecedor(null);
                    setFornecedorTexto("");
                    setFuncionarioSelecionado(null);
                  }}
                  className="customInputSelect"
                  value={tipoBeneficiario}
                >
                  <option value="fornecedor">Fornecedor</option>
                  <option value="cliente">Cliente</option>
                  <option value="funcionario">Funcionário</option>
                </select>
                <label className="customInputLabelSelect">
                  Tipo de Beneficiário
                </label>
              </div>
            </div>

            {tipoBeneficiario === "fornecedor" && listaFornecedores && (
              <div
                className="adicionar-despesa__modal__container--span2"
                style={{ position: "relative" }}
              >
                <Autocomplete
                  className="saida__autocomplete"
                  freeSolo
                  options={listaFornecedores}
                  getOptionLabel={(option) =>
                    typeof option === "string" ? option : option.value
                  }
                  value={
                    fornecedor
                      ? listaFornecedores.find((f) => f.id === fornecedor) ||
                        null
                      : fornecedorTexto || null
                  }
                  onChange={(event, newValue) => {
                    if (typeof newValue === "string") {
                      handleFornecedorChange(newValue, true);
                    } else if (newValue && newValue.id) {
                      handleFornecedorChange(newValue.id, false);
                    } else {
                      handleFornecedorChange("", false);
                    }
                  }}
                  onInputChange={(event, newInputValue) => {
                    if (event?.type === "change") {
                      const opcaoExistente = listaFornecedores.find(
                        (f) => f.value === newInputValue,
                      );
                      if (opcaoExistente) {
                        handleFornecedorChange(opcaoExistente.id, false);
                      } else {
                        handleFornecedorChange(newInputValue, true);
                      }
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Fornecedor"
                      variant="outlined"
                    />
                  )}
                />
              </div>
            )}

            {tipoBeneficiario === "cliente" && listaClientes && (
              <div className="adicionar-despesa__modal__container--span2">
                <Autocomplete
                  className="saida__autocomplete"
                  freeSolo
                  options={listaClientes}
                  getOptionLabel={(option) =>
                    typeof option === "string" ? option : option.nome
                  }
                  value={listaClientes.find((c) => c.id === cliente) || null}
                  onChange={(event, newValue) => {
                    if (typeof newValue === "string") {
                      handleClienteChange(newValue);
                    } else if (newValue && newValue.id) {
                      handleClienteChange(newValue.id);
                    } else {
                      handleClienteChange("");
                    }
                  }}
                  onInputChange={(event, newInputValue) => {
                    if (event?.type === "change") {
                      handleClienteChange(newInputValue);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Cliente" variant="outlined" />
                  )}
                />
              </div>
            )}

            {tipoBeneficiario === "funcionario" && (
              <div className="adicionar-despesa__modal__container--span2">
                <Autocomplete
                  className="saida__autocomplete"
                  options={listaFuncionariosEUtilizadores}
                  getOptionLabel={(option) => option.value}
                  groupBy={(option) =>
                    option.tipo === "Funcionario"
                      ? "Funcionários"
                      : "Utilizadores do Sistema"
                  }
                  value={funcionarioSelecionado}
                  onChange={(event, newValue) => {
                    setFuncionarioSelecionado(newValue); // guarda o objeto inteiro {id, value, tipo}
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Funcionário"
                      variant="outlined"
                    />
                  )}
                />
              </div>
            )}

            {categorias && categoria && (
              <div className="customInputContainer adicionar-despesa__modal__container--span2">
                <select
                  onChange={(e) => setCategoria(e.target.value)}
                  className="customInputSelect"
                  value={categoria}
                >
                  {categorias &&
                    categoria &&
                    categorias.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.value}
                      </option>
                    ))}
                </select>
                <label className="customInputLabelSelect">Categoria*</label>
                <Link to={`../../configuracoes/categoriasFinanceiro`}>
                  <ControlPointIcon className="customInputPlusSign" />
                </Link>
              </div>
            )}

            {caixas && caixa && (
              <div className="customInputContainer adicionar-despesa__modal__container--span2">
                <select
                  onChange={(e) => caixaChangeHandler(e.target.value)}
                  className="customInputSelect"
                  value={caixa}
                >
                  {/* Enquanto a saída não é dada como paga não há método, e
                      todas as caixas servem. A partir daí manda a regra. */}
                  {(saidaPaga
                    ? caixasPermitidas(caixas, metodoPagamento)
                    : caixas
                  ).map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.value}
                    </option>
                  ))}
                </select>
                <label className="customInputLabelSelect">Caixa*</label>
                <Link to={`../../configuracoes/caixas`}>
                  <ControlPointIcon className="customInputPlusSign" />
                </Link>
              </div>
            )}

            <textarea
              cols="30"
              rows="7"
              placeholder="observacao"
              value={observacao}
              onChange={(e) => setObservacao(e.target.value)}
              className="adicionar-despesa__modal__container__textarea"
            ></textarea>
          </div>

          <div className="adicionar-despesa__modal__container__checkbox-pago__container">
            <input
              type="checkbox"
              name=""
              id="ja-foi-pago-checkbox"
              onChange={(e) => setSaidaPaga(e.target.checked)}
              checked={saidaPaga}
            />
            <label htmlFor="ja-foi-pago-checkbox">Essa saída já foi paga</label>
          </div>

          {saidaPaga && (
            <>
              <div className="adicionar-despesa__modal__pagamento">
                <LocalizationProvider
                  dateAdapter={AdapterMoment}
                  className="adicionar-despesa__modal__container--span1"
                >
                  <DesktopDatePicker
                    className="valorDataCaixa__fields--field muiDatePicker"
                    label="Data do Pagamento*"
                    inputFormat="DD-MM-YYYY"
                    value={dataPagamento}
                    onChange={(value) => setDataPagamento(value)}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>

                <InputSelect
                  label="Forma de pagamento*"
                  initialValue={metodoPagamento}
                  handleChange={metodoPagamentoChangeHandler}
                  items={formasPagamento}
                />

                {(metodoPagamento === "Cheque" ||
                  metodoPagamento === "Cheque Visado") && (
                  <div
                    style={{
                      gridColumn: "1/-1",
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr 1fr 1fr",
                      gap: "15px",
                      marginTop: "25px",
                    }}
                  >
                    <InputText
                      className="adicionar-despesa__modal__container--span1"
                      label="Banco"
                      initialValue={banco}
                      handleChange={setBanco}
                      id="bancoId"
                    />
                    <InputText
                      className="adicionar-despesa__modal__container--span1"
                      label="Nº Conta Cliente *"
                      initialValue={nrContaCliente}
                      handleChange={setNrContaCliente}
                      id="nrContaClienteID"
                    />
                    <InputText
                      className="adicionar-despesa__modal__container--span1"
                      label="Nº Cheque *"
                      initialValue={nrCheque}
                      handleChange={setNrCheque}
                      id="NrChequeID"
                    />
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DesktopDatePicker
                        className="valorDataCaixa__fields--field muiDatePicker"
                        label="Data do Cheque *"
                        inputFormat="DD-MM-YYYY"
                        value={dataCheque}
                        onChange={(value) => setDataCheque(value)}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </div>
                )}
              </div>

              {comprovativo && (
                <div className="despesas--comprovativo-selecionado">
                  Comprovativo Selecionado: {comprovativo.name}
                </div>
              )}
              <div>
                <input
                  type="file"
                  style={{ display: "none" }}
                  id="fileInput"
                  onChange={handleFileChange}
                />
                <label htmlFor="fileInput" className="anexar-comprovativo">
                  {comprovativo
                    ? "Substituir comprovativo"
                    : "Anexar comprovativo"}
                </label>
              </div>

              <div className="despesas--regras-ficheiro">
                <span className="modalAdicionarFicheiros__container-adicionar--regras-ficheiro">
                  O Tamanho máximo do upload é 1MB
                </span>
                <span className="modalAdicionarFicheiros__container-adicionar--regras-ficheiro">
                  Formatos aceites: .pdf, .png, .jpg e .jpeg
                </span>
              </div>
            </>
          )}

          {errorMessage && (
            <div className="modal-mensagem-de-erro">
              <span>{errorMessage}</span>
            </div>
          )}

          <div className="fluxo-atendimento__modal__bottom_btns">
            <span
              className="cancel-btn"
              onClick={handleCloseModalSaida}
              style={{ display: "block" }}
            >
              Fechar
            </span>

            <span
              disabled={isSubmitting || errorMessage}
              className="blue-button"
              onClick={preGuardarSaidaHandler}
            >
              {isSubmitting ? "Guardando..." : "Guardar"}
            </span>
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default ModalSaida;
